// File: DIR3KYCForDirectors.jsx
import React from "react";

export default function DIR3KYCForDirectors() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            DIR-3 KYC for Directors
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists directors with annual DIR-3 KYC compliance.
          </p>
          <p className="text-gray-700">
            Complete DIR-3 KYC process including MCA V3 portal filing, document verification, DSC attestation, professional certification, and penalty avoidance for DIN holders.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: DIR-3 KYC - director compliance documents) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/669611/pexels-photo-669611.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="DIR-3 KYC compliance for company directors"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless DIR-3 KYC filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card copy</li>
                <li>Aadhaar card copy</li>
                <li>Address proof (Passport/Voter ID)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Timely filing, penalty avoidance with proven MCA DIR-3 KYC compliance expertise.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  DIR-3 KYC Web Filing Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete DIR-3 KYC web service filing before 30th September annually, MCA V3 portal navigation, mobile/email/OTP verification, professional CA/CS/CMA certification, and SRN generation tracking.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Penalty Avoidance & DIN Reactivation
                </h3>
                <p className="text-gray-700 text-sm">
                  Rs.5,000 late fee avoidance through timely filings, DIN deactivation prevention, reactivation support for non-compliant directors, document verification, and compliance status monitoring.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  End-to-End Director Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service KYC from document collection through DSC attestation, professional certification, MCA approval tracking, compliance certificate issuance, DIN portfolio management, and annual reminders.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
